import { CourseData, coursesApi } from "api/courses/coursesApi";
import { IDropdownOption } from "components/atoms";
import { QUERIES_KEYS } from "queries";
import { keepPreviousData, useQuery } from "@tanstack/react-query";

export const useCourses = (
  skip: number,
  limit: number,
  searchPhrase: string = "",
  filter: string = "",
  orderBy: string = "",
) => {
  const { isFetching, isLoading, data, refetch } = useQuery({
    queryKey: QUERIES_KEYS.COURSES(skip, limit, searchPhrase, filter, orderBy),
    queryFn: () => coursesApi.fetch(skip, limit, searchPhrase, filter, orderBy),
    placeholderData: keepPreviousData,
  });

  return { isFetching, isLoading, data: data?.data?.data ?? [], total: data?.data?.total ?? 0, refetch };
};

export interface CourseOption extends IDropdownOption {
  course?: CourseData;
}
export const useCoursesOptions = (searchPhrase: string = "", filter: string = "") => {
  const { isLoading, data } = useCourses(0, 1_000_000, searchPhrase, filter);

  const options: CourseOption[] = data?.map((x) => ({
    value: x.id.toString(),
    label: x.name,
    course: x,
  }));

  return { isLoading, options };
};
